import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class Wohnungverm extends AbstractRequirementMapper {
  protected frontendKey = 'leistungsumfang.vermietung';
}
